module.exports = "/_next/static/images/top-7298a41d42e3deb835ef630bc2669b64.jpg";